import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArrayBy',
})
export class FilterArrayByPipe implements PipeTransform {
  transform(array: any[], objKey: string, value: any, additionalValue?: any): any[] {
    if (array && objKey) {
      return array.filter((val) => val[objKey] === value || (additionalValue && val[objKey] === additionalValue));
    }
    return array;
  }
}
